export const SPLIT_MODE_MESSAGE_ID = 'resource-planning-split-mode-message';
